import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ChartType, ChartDataset } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

export class DoughnutChartData {
  label: string;
  value: number;
}

@Component({
    selector: 'doughnut-chart',
    templateUrl: './doughnut-chart.component.html',
    styleUrls: ['./doughnut-chart.component.css'],
    standalone: false
})
export class DoughnutChartComponent implements OnInit {
  @ViewChild(BaseChartDirective, { static: false }) baseChart: BaseChartDirective;
  @Input() data: Array<DoughnutChartData>;

  public doughnutChartLabels: string[] = [];
  public doughnutChartData: ChartDataset[] = [
    {
      data: [],
      backgroundColor: ['#57d457', '#ff5959']
    }
  ];
  public doughnutChartType: ChartType = 'doughnut';

  constructor() { }

  ngOnInit() {
    this.setChartData();
  }

  ngOnChanges(): void {
    this.setChartData();
  }

  private setChartData(): void {
    if (this.data) {
      setTimeout(() => {
        const dataPoints: number[] = [];
        const labels: string[] = [];

        this.data.forEach(item => {
          dataPoints.push(item.value);
          labels.push(item.label);
        });

        this.doughnutChartLabels = labels;
        this.doughnutChartData = [{
          data: dataPoints,
          backgroundColor: ['#57d457', '#ff5959']
        }];

        this.baseChart?.chart?.update();
      }, 100);
    }
  }
}
